import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "",
        "assetDirectory": "/",
        "title": "Hitch the HiLux and the GREAT Aussie Road Trip",
        "shortTitle": "Hitch",
        "appKey": "472357ac-181c-40c0-a6b3-8ef884c1bb3b",
        "language": "en",
        "languages": [
            "en"
        ],
        "about": "",
        "buildNumber": 452356,
        "buildDate": "2026-05-21T18:24:06.416Z",
        "version": "2.11.1"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": false,
            "type": "cognito",
            "config": {
                "host": "",
                "clientId": "",
                "customerPortalUrl": ""
            }
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "toyota"
        },
        "legal": {
            "tou": {
                "url": "",
                "label": ""
            },
            "privacy": {
                "url": "",
                "label": ""
            },
            "cookie": {
                "url": "",
                "label": ""
            }
        },
        "cache": {
            "ttl": {
                "getAllIssues": 5,
                "previewIssue": 5,
                "getIssue": 5,
                "getFeatureArticles": 5,
                "styles": 5
            }
        },
        "menu": {
            "externalUrl": {
                "enabled": false,
                "url": "/",
                "title": "Toyota"
            },
            "links": []
        }
    },
    "issue": {
        "contentType": "replica",
        "lastLocation": {
            "enabled": false
        },
        "replica": {
            "default": "double"
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 0
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "metaPixel": {
            "trackerID": ""
        },
        "tiktokPixel": {
            "trackerID": ""
        },
        "gtag": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {}
    }
};
export default config;